import React, { FC } from 'react';
import { WRESTLER_TIERS } from '@wwe-portal/web/utils/superstar-details/constants';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@wwe-portal/ui/components/dropdown';
import { Each } from '@wwe-portal/ui/components/utils';
import { ClickableDiv } from '@wwe-portal/ui/components/button/clickable-div';
import { cn } from '@wwe-portal/ui/lib/lib';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';

interface TierDropdownProps {
  wrestlerTier: string;
  wrestlerTierDropdownItemClick: (tier: 'Bronze' | 'Silver' | 'Gold') => void;
  className?: string;
}

const TierDropdown: FC<TierDropdownProps> = ({
  wrestlerTier,
  wrestlerTierDropdownItemClick,
  className,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <DropdownMenu onOpenChange={() => setIsOpen((isOpen) => !isOpen)}>
      <DropdownMenuTrigger asChild>
        <ClickableDiv
          className={cn(
            'border-back200 bg-back300 text-text500 flex h-[46px] w-full items-center justify-between rounded border-0 border-l-[1px] border-solid px-5 py-2.5 text-center text-sm font-medium',
            className
          )}
        >
          {wrestlerTier}
          <IcoMoonIcon
            iconName="arrow"
            className={cn(
              'text-inlineTextColor18 size-4 transition-transform',
              {
                'rotate-180': isOpen,
              }
            )}
          />
        </ClickableDiv>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={'start'}
        isQualMenuWidth={true}
        className="bg-back200 text-text600"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
        }}
      >
        <div className="no-scrollbar pointer-events-auto max-h-[360px] overflow-y-auto">
          <Each
            data={[...WRESTLER_TIERS]}
            render={(tier: 'Bronze' | 'Silver' | 'Gold') => (
              <DropdownMenuItem
                key={tier}
                className={cn(
                  'hover:bg-back300 cursor-pointer rounded-xl px-2 capitalize'
                )}
                onClick={() => {
                  wrestlerTierDropdownItemClick(tier);
                }}
              >
                {tier}
              </DropdownMenuItem>
            )}
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
export default TierDropdown;
